@if (product$ | async; as product) {
  <ng-template
    [cxOutlet]="outlets.PRICE"
    [cxOutletContext]="{ product: product }"
    >
    <div class="price" aria-label="new item price">
      {{ product?.price?.formattedValue }}
      @if (product?.price?.discountValue) {
        <span class="old-price">{{ product?.price?.originalPrice.formattedValue}}</span>
        <span class="discount">{{ product?.price?.discountPercentage }}</span>
      }
    </div>
    @if (product?.price?.discountValue) {
      <div class="discount-price">
        {{ 'productSummary.save' | cxTranslate}} ({{product?.price?.discountValue.formattedValue}})
      </div>
    }
    @if (product?.pricePerPiece?.length) {
      <div class="text-light">
        {{ 'addToCart.volumePrice.unitPrice' | cxTranslate: { unitPrice: product.pricePerPiece } }}
      </div>
    }
  </ng-template>
  <!-- @TODO: Temp. Comment out share link while not in use by CMS -->
  <!-- <ng-container *cxOutlet="outlets.SHARE">
  <div>
    <a href="#" class="share btn-link">
      {{ 'productSummary.share' | cxTranslate }}
    </a>
  </div>
</ng-container> -->
}
